<template>
  <div>
    <div class="table-header mt-16">
      <div class="flex justify-between items-center">
        <div class="table__search-input-wrapper">
          <span class="pr-2 opacity-50"><search-icon /> </span>
          <input
            type="text"
            class="table__search-input"
            placeholder="Search..."
            v-model="queryString"
          />
          <img src="@/assets/images/icons/search.svg" alt="search icon" />
        </div>
      </div>

      <div
        v-if="selectedContactIds.length"
        class="rounded restore-button py-2 flex justify-center items-center cursor-pointer"
        @click="isRestoreModal = true"
      >
        <p>Restore</p>
      </div>
    </div>

    <div class="table-wrapper" id="table-wrapper">
      <table class="custom-table responsive-table">
        <thead>
          <tr>
            <th><base-checkbox v-model="selectAll" /></th>
            <th>CUSTOMER NAME</th>
            <th>PROFILE NAME</th>
            <th>MULEEX ID</th>
            <th>BILLING ADDRESS</th>
            <th>CONTACT PERSON</th>
            <th>REGISTERED BY</th>
            <th>REG. CHANNEL</th>
            <th class="relative" tabindex="-1">
              <span class="cursor-pointer">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g opacity="0.7">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M4 0.130371C5.86384 0.130371 7.42994 1.46057 7.87398 3.26081H16V5.34776H7.87398C7.42994 7.148 5.86384 8.4782 4 8.4782C1.79086 8.4782 0 6.60947 0 4.30428C0 1.9991 1.79086 0.130371 4 0.130371ZM4 6.39124C5.10457 6.39124 6 5.45688 6 4.30428C6 3.15169 5.10457 2.21733 4 2.21733C2.89543 2.21733 2 3.15169 2 4.30428C2 5.45688 2.89543 6.39124 4 6.39124Z"
                      fill="#383F51"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M14 17.8695C12.1362 17.8695 10.5701 16.5393 10.126 14.7391H2V12.6521H10.126C10.5701 10.8519 12.1362 9.52168 14 9.52168C16.2091 9.52168 18 11.3904 18 13.6956C18 16.0008 16.2091 17.8695 14 17.8695ZM14 15.7825C15.1046 15.7825 16 14.8482 16 13.6956C16 12.543 15.1046 11.6086 14 11.6086C12.8954 11.6086 12 12.543 12 13.6956C12 14.8482 12.8954 15.7825 14 15.7825Z"
                      fill="#383F51"
                    />
                  </g></svg
              ></span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="contact in filteredContacts"
            :key="contact.id"
            class="cursor-pointer"
          >
            <!-- @click="viewContactProfile(contact.id)" -->
            <td>
              <base-checkbox :value="contact.id" v-model="selectedContactIds" />
            </td>
            <td @click="viewContactProfile(contact.id)">{{ contact.name }}</td>
            <td>On-Demand</td>
            <td>{{ contact.code }}</td>
            <td>{{ contact.location }}</td>
            <td>{{ contact.contactPerson }}</td>
            <td>Self</td>
            <td>MuleEx</td>
            <td class="relative" tabindex="-1" @blur="selectedRowId = null">
              <span
                @click="
                  selectedRowId
                    ? (selectedRowId = null)
                    : (selectedRowId = contact.id)
                "
                ><vertical-ellipsis
              /></span>
              <action-popup width="w-48" v-if="selectedRowId == contact.id">
                <div>
                  <p
                    class="py-1"
                    @click="
                      (selectedContact = contact), (isRestoreModal = true)
                    "
                  >
                    Restore
                  </p>
                </div>
              </action-popup>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div
      v-if="!blacklistedContacts.length && !loading"
      class="bg-white w-100 flex justify-center flex-col items-center p-5"
    >
      <empty-table-icon />
      <p class="font-semibold pt-3">
        No blacklisted customers.!
      </p>
    </div>
    <loader v-if="loading" />
    <pagination-control />

    <!-- Modals -->
    <restore-contact-form
      v-if="isRestoreModal"
      :show-modal="isRestoreModal"
      @close-modal="isRestoreModal = false"
      :contact="selectedContact"
      :contactIds="selectedContactIds"
      @contact-restored="getAllBlacklistedContacts"
    />
    <!-- Modals -->
  </div>
</template>

<script>
import PaginationControl from "@/components/UI/NewPagination";
import RestoreContactForm from "./Modals/RestoreContact";
export default {
  components: {
    PaginationControl,
    RestoreContactForm,
  },
  data() {
    return {
      blacklistedContacts: [],
      selectedRowId: null,
      isLoyaltyGroupModal: false,
      isBlacklistContactModal: false,
      loading: true,
      selectedContact: {},
      isRestoreModal: false,
      queryString: "",
      selectAll: false,
      selectedContactIds: [],
    };
  },
  computed: {
    filteredContacts() {
      return this.filterArray(this.blacklistedContacts, this.queryString);
    },
  },
  watch: {
    selectAll(val) {
      if (val) {
        this.blacklistedContacts.forEach((contact) => {
          this.selectedContactIds.push(contact.id);
        });
      } else {
        this.selectedContactIds = [];
      }
    },
  },
  mounted() {
    this.getAllBlacklistedContacts();
  },
  methods: {
    async getAllBlacklistedContacts() {
      this.loading = true;
      try {
        const response = await this.$_getAllBlacklistedContacts();
        this.logResponse(response);
        this.blacklistedContacts = response.data.contacts;
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false;
    },
    viewContactProfile(contactId) {
      localStorage.setItem("customerId", contactId);
      this.$router.push({ name: "CustomerProfile" });
    },
  },
};
</script>

<style lang="scss" scoped>
.table__search-input-wrapper {
  background: #f7fafd;
  width: 20rem;
  border-radius: 5px;
}
.custom-table,
.table-wrapper {
  margin-bottom: 0;
}
th {
  color: #707684;
  font-size: 0.8rem;
  padding: 0.5rem;
}

td {
  background: #ffffff;
  color: var(--primaryblue);
  font-weight: 500;
  border-radius: 2px;
  padding: 1rem 0.75rem;
  vertical-align: top;

  span {
    display: block;
  }
  span:last-of-type {
    font-weight: normal;
    color: #10233e;
    opacity: 0.6;
    padding-top: 0.25rem;
    font-size: 0.8rem;
  }
}
.checkbox {
  display: initial;
  width: 1rem;
  height: 1rem;
}
table {
  border-collapse: separate;
  border-spacing: 0 0.5rem;
}
.restore-button {
  width: 10rem;
  background: #10233e;
  color: #ffffff;
  text-align: center;
}
</style>
